"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementEarnedDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const utility_1 = require("../decorators/utility");
const achievement_1 = require("../types/achievement");
const dto_factory_1 = require("../types/dto-factory");
let AchievementEarnedDTO = class AchievementEarnedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.AchievementEarnedDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "category", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "imageUri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rewards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('User achievement ID'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('User ID'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Achievement name'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Achievement description'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Achievement category'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Achievement platform'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "platform", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Achievement image URI'),
    __metadata("design:type", String)
], AchievementEarnedDTO.prototype, "imageUri", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => achievement_1.AchievementReward }),
    (0, decorators_1.Describe)('Achievement rewards'),
    __metadata("design:type", Array)
], AchievementEarnedDTO.prototype, "rewards", void 0);
AchievementEarnedDTO = __decorate([
    (0, decorators_1.Describe)('User achievement earned')
], AchievementEarnedDTO);
exports.AchievementEarnedDTO = AchievementEarnedDTO;
